import React, { useState, ImgHTMLAttributes, useMemo, useEffect } from 'react';
import { getFallbackImageByType } from '@sportal365/smp-widget-utils/src/images';
import { assetsPlaceholder } from '../constants/assetsPlaceholder';
import { IMAGE_ENTITY } from '../constants/entityTypes';

interface ImageWrapperProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string | undefined;
  alt: string | undefined;
  classNames?: string;
  entityType: string;
}

const Image: React.FC<ImageWrapperProps> = ({ src, alt, classNames, entityType, onError, ...props }) => {
  const fallbackImg = useMemo(() => getFallbackImageByType(entityType), [entityType]);
  const [currentSrc, setCurrentSrc] = useState(src || fallbackImg);
  const [hasError, setHasError] = useState(false);

  // Update currentSrc when src prop changes
  useEffect(() => {
    if (src && !hasError) {
      setCurrentSrc(src);
    }
  }, [src, hasError]);

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (!hasError) {
      // Set to fallback from entityType first
      setCurrentSrc(fallbackImg);
      setHasError(true);

      // If the fallback also fails, use the empty placeholder
      if (currentSrc === fallbackImg) {
        setCurrentSrc(assetsPlaceholder.empty);
      }
    }

    if (onError) {
      onError(event); // Call original onError if provided
    }
  };

  return <img src={currentSrc} alt={alt || IMAGE_ENTITY} className={classNames} onError={handleError} {...props} />;
};

export default Image;
